import {FC, useCallback, useMemo} from "react";
import {useTranslation} from "react-i18next";
import {API, Endpoints, Project} from "@brg/api";
import {useToasts} from "@brg/ui";
import {downloadPDF} from "./model/downloadPDF";
import styled, {useTheme} from "styled-components";
import {LayoutConst} from "../../../core";

const PrintProjectButton = styled.div<{isPresentation?: boolean}>`
  
  display: flex;
  justify-content: center;
  align-items: center;
  height: 46px;
  padding: 0 48px;
  cursor: pointer;
  font-size: 17px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px; /* 129.412% */
  letter-spacing: -0.34px;
  border: 1px solid #909090;
  border-radius: 3px;
  width: fit-content;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 15px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px; /* 133.333% */
    letter-spacing: -0.3px;
    height: 36px;
  }
  @media (max-width: ${LayoutConst.screen.s}px) {
    margin-left: ${({isPresentation}) => isPresentation ? '0px' : '10px'};
    width: 100%;
  }
`

export const PrintProject: FC<{project: Project, isPresentation?: boolean, isOutsideTextPosition?: boolean}> = ({project, isPresentation = false, isOutsideTextPosition = false}) => {

    const { i18n, t } = useTranslation();
    const {error, info} = useToasts();
    const theme = useTheme()

    const printPDFForm = useMemo(() => ({
        orientation: true,
        size: 'A4',
        localization: i18n.language,
        projectId: project?.projectId,
        pathUrlProjectRequest: 'testPp',
        pathUrlLongreadRequest: 'testLn',
        isPresentation: isPresentation,
        isOutsideTextPosition: isOutsideTextPosition,
    }), [project, i18n.language, isPresentation, isOutsideTextPosition]);


    const printPdfCard = useCallback(() => {

        info(t('print_project_toast'))

        API.request()
            .endpoint(Endpoints.geograffee)
            .url('/api/Project/PrintPdf')
            .post()
            .body(printPDFForm)
            .send()
            .then((r) => r.json())
            .then((r) => r?.length > 0 ? downloadPDF(r, project?.title, error, info, t) : console.error('no files'))
            .catch((e) => console.error(e))
    }, [printPDFForm, t]);


    return <PrintProjectButton isPresentation={isPresentation} style={{color: theme.projectTools.printButton}} onClick={printPdfCard}>{t('print_project')}</PrintProjectButton>
}import {FC, useCallback, useMemo} from "react";
import {useTranslation} from "react-i18next";
import {API, Endpoints, Project} from "@brg/api";
import {useToasts} from "@brg/ui";
import {downloadPDF} from "./model/downloadPDF";
import styled, {useTheme} from "styled-components";
import {LayoutConst} from "../../../core";

const PrintProjectButton = styled.div<{isPresentation?: boolean}>`
  
  display: flex;
  justify-content: center;
  align-items: center;
  height: 46px;
  padding: 0 48px;
  cursor: pointer;
  font-size: 17px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px; /* 129.412% */
  letter-spacing: -0.34px;
  border: 1px solid #909090;
  border-radius: 3px;
  width: fit-content;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 15px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px; /* 133.333% */
    letter-spacing: -0.3px;
    height: 36px;
  }
  @media (max-width: ${LayoutConst.screen.s}px) {
    margin-left: ${({isPresentation}) => isPresentation ? '0px' : '10px'};
    width: 100%;
  }
`

export const PrintProject: FC<{project: Project, isPresentation?: boolean, isOutsideTextPosition?: boolean}> = ({project, isPresentation = false, isOutsideTextPosition = false}) => {

    const { i18n, t } = useTranslation();
    const {error, info} = useToasts();
    const theme = useTheme()

    const printPDFForm = useMemo(() => ({
        orientation: true,
        size: 'A4',
        localization: i18n.language,
        projectId: project?.projectId,
        pathUrlProjectRequest: 'testPp',
        pathUrlLongreadRequest: 'testLn',
        isPresentation: isPresentation,
        isOutsideTextPosition: isOutsideTextPosition,
    }), [project, i18n.language, isPresentation, isOutsideTextPosition]);


    const printPdfCard = useCallback(() => {

        info(t('print_project_toast'))

        API.request()
            .endpoint(Endpoints.geograffee)
            .url('/api/Project/PrintPdf')
            .post()
            .body(printPDFForm)
            .send()
            .then((r) => r.json())
            .then((r) => r?.length > 0 ? downloadPDF(r, project?.title, error, info, t) : console.error('no files'))
            .catch((e) => console.error(e))
    }, [printPDFForm, t]);


    return <PrintProjectButton isPresentation={isPresentation} style={{color: theme.projectTools.printButton}} onClick={printPdfCard}>{t('print_project')}</PrintProjectButton>
}